import { duplicateWithIndex } from "../../../helpers/duplicateWithIndex";

export default [
    {
        key: "dopolnitelnaya_polka",
        allArray: "allPolkaStellazh",
        activeArray: "activePolkaStellazh",
        position: "top",
        extra: (el) => duplicateWithIndex(el, 11, servObj.allPolkaStellazh),
    },
];
